import { Button } from '@mui/material'
import Link from 'next/link'

const TeamMemberCard = ({ post }) => {
  // console.log(post)
  const slug = post?.slug || ''
  const name =
    post?.team_member_name || post?.name || post?.title || 'Unnamed Member'
  const position =
    post?.position || post?.team_position || post?.job_title || ''
  const tag = post?.tag || post?.team_tag || ''
  const imageUrl = post?.profile_image?.url

  const profileHref = `/team/profile/${slug}`

  return (
    <Link
      href={profileHref}
      className="tw:relative tw:duration-300 tw:h-full tw:shadow-md tw:hover:shadow-xl tw:sm:px-6 tw:px-2 tw:pb-2 tw:pt-4 tw:rounded-lg tw:text-center tw:flex tw:flex-col tw:items-center tw:hover:translate-y-[-0.5rem] tw:border tw:border-gray-200 tw:bg-white"
    >
      {tag ? (
        <span className="tw:absolute tw:-top-3 tw:right-3 tw:uppercase tw:bg-white tw:shadow tw:text-black tw:text-[11px] tw:px-2 tw:py-0.5 tw:rounded tw:border tw:border-gray-200">
          {tag}
        </span>
      ) : null}
      <div>
        <img
          src={imageUrl}
          alt={name ? `${name}'s profile photo` : 'Profile photo'}
          className="tw:w-32 tw:h-32 tw:border-[4px] tw:border-neutral-200 tw:rounded-full tw:object-cover tw:object-top tw:mx-auto"
          loading="lazy"
        />
      </div>
      <div className="tw:flex tw:flex-col tw:h-full tw:w-full tw:justify-between tw:gap-2 tw:pt-3">
        <div className="tw:my-3">
          <h6
            className="tw:font-semibold tw:text-black"
            dangerouslySetInnerHTML={{ __html: name }}
          />
          <h6
            className="tw:text-sm tw:mt-1 tw:text-gray-500"
            dangerouslySetInnerHTML={{ __html: position }}
          />
        </div>
        <div className="tw:mb-3 tw:w-full">
          <Button variant="contained" color="primary">
            <span className="tw:text-sm">View Profile</span>
          </Button>
        </div>
      </div>
    </Link>
  )
}

export default TeamMemberCard
